export default __webpack_public_path__ + "static/media/7.b33f0897.png";